import styled from 'styled-components';

export const StyledBarChart = styled.div`
    height: 10px;
`;
